<template>
    <div class="brt-map-overviewModule" ref="overviewModule" v-if="moduleState">

        <div class="wrap">

            <ul  :class="moduleState == 0 ? 'query-floor':'query-floor show'" v-if="queryFloor && $store.state.mapStore.isShow(moduleState,[2])">
                <li v-for="(item,index) in queryFloor" @click="changeView(item)">{{item.floorName}} <i :class="item.state?item.state:''"></i></li>
            </ul>

            <div :class="moduleState == 2 ? 'box on':(moduleState == 3 ? 'view box':'box')" @click = "viewBtn">
                <span>全览</span>
                <span>返回</span>
            </div>

        </div>

    </div>
</template>

<script>

    import {getPoiInfo} from './../../brtmap/Brtmap.js'

    export default {
        name: "OverviewModule",
        data(){
            return {
                moduleState:0,
                beforeZoom:0,    //全览之前的层级
                queryFloor:[
                    // {
                    //     floorName:'F1',
                    //     state:'start'
                    // },
                    // {
                    //     floorName:'F2'
                    // },
                    // {
                    //     floorName:'F3'
                    // },
                    // {
                    //     floorName:'F4',
                    //     state:'end'
                    // },
                ]
            }
        },

        created(){
            this.bus.$off('overViewNo');
            this.bus.$on('overViewNo',()=>{ //退出全览
                this.moduleState = 2;
                this.viewBtn();
            })

        },

        methods:{

            setView(route){

                // console.log('route',route);

                this.queryFloor=[];
                let $queryFloor=[];

                if(route){

                    if(route.length == 1){

                        this.moduleState = 3

                    }else{

                        let $selecte=this.$store.state.mapStore.brtmap.$selecte;

                        if(!$selecte.startPoint || !$selecte.endPoint)return;//防止为空

                        $selecte.startPoint.floor = $selecte.startPoint.floor ? $selecte.startPoint.floor : $selecte.startPoint.FLOOR_NUMBER;
                        $selecte.endPoint.floor = $selecte.endPoint.floor ? $selecte.endPoint.floor : $selecte.endPoint.FLOOR_NUMBER;


                        for(let i = 0 ; i< route.length;i++){

                            let r = route[i].mapInfo,isrepeat = null;

                            r.state = '';

                            //显示小点
                            if(r.floorNumber == $selecte.startPoint.floor){
                                r.state += ' start';
                            }

                            if( r.floorNumber == $selecte.endPoint.floor ){

                                r.state += ' end';
                            }

                            if(r.floorNumber != $selecte.endPoint.floor && r.floorNumber != $selecte.startPoint.floor){
                                r.state = '';
                            }


                            $queryFloor.push(r);

                            // //去重
                            // if($queryFloor.length > 0){
                            //
                            //     isrepeat=$queryFloor.some(function (item,index,self) {
                            //         return item.floorID == r.floorID
                            //     })
                            //
                            // }
                            //
                            // if(!isrepeat){$queryFloor.push(r);}

                        }

                        this.queryFloor = $queryFloor;
                        this.moduleState = 1;
                    }

                }else{

                    this.moduleState = false;

                }

            },

            changeView(item) {

                this.bus.$emit('overViewNAVING',{status:1})//重置

                let floorID = item.floorID,
                    $this = this;

                this.moduleState =2;

                let $brtmap = this.$store.state.mapStore.brtmap, route = $brtmap.$route.route;


                function _getCoords(floorID) {

                    var moreCoordinates = [];	//起终点同层楼

                    for (var i = 0; i < route.length; i++) {

                        var _routePart = route[i];

                        if (_routePart.mapInfo.mapID == floorID) {
                            moreCoordinates.push(_routePart.coordinates);
                        }

                    }

                    if (moreCoordinates.length > 0) {
                        return moreCoordinates
                    }

                    return null;

                }

                var _floorID = floorID ? floorID : $VAR.map.getFloorInfoByIndex($brtmap.$selecte.endPoint.floor);

                var coordinates = _getCoords(_floorID)[0];
                if (!coordinates) return;

                var coordinatesArr=_getCoords(_floorID);

                function _callee() {

                    var bounds = coordinates.reduce(function (bounds, coord) {

                        return bounds.extend(coord);

                    }, new brtmap.LngLatBounds(coordinates[0], coordinates[0]));

                    // $VAR.map.setMaxBounds(null);

                    $VAR.map.fitBounds(bounds, {

                        padding: {
                            top: 160,
                            left: 80,
                            right: 80,
                            bottom: 200
                        },

                        pitch: 0,
                    });

                    //多路段
                    if(coordinatesArr.length >1){

                        $VAR.map.easeTo({
                            zoom:$VAR.map.getBaseZoom(),
                            center:$VAR.map.getCenter()
                        })

                    }

                    //插标
                    setTimeout(()=>{

                        let $startPoint = $brtmap.$selecte.startPoint,$endPoint = $brtmap.$selecte.endPoint;

                        //起点为定位点
                        if($startPoint && $startPoint.x && $startPoint.y){

                            //getMapPoi很容易返回null
                            let lngLat =  $VAR.map.coordsToLnglat($startPoint.x,$startPoint.y);
                            // $brtmap.$selecte.startPoint = $VAR.map.getMapPoi(lngLat) ? $VAR.map.getMapPoi(lngLat,$VAR.map.getFloorInfoByIndex($startPoint.floor).floorID).properties : $brtmap.$selecte.startPoint;
                            $startPoint = getPoiInfo($brtmap,$VAR.map.project(lngLat));
                        }


                        //终点为定位点
                        if($endPoint && $endPoint.x && $endPoint.y){

                            let lngLat =  $VAR.map.coordsToLnglat($endPoint.x,$endPoint.y);
                            $endPoint = getPoiInfo($brtmap,$VAR.map.project(lngLat));

                        }


                        if($startPoint && $VAR.map.currentMapInfo.floorNumber == $startPoint.floor){
                            $brtmap.$marker.start.setLnglat($VAR.map.coordsToLnglat($startPoint.LABEL_X,$startPoint.LABEL_Y))
                        }


                        if($endPoint && $VAR.map.currentMapInfo.floorNumber == $endPoint.floor){
                            $brtmap.$marker.end.setLnglat($VAR.map.coordsToLnglat($endPoint.LABEL_X,$endPoint.LABEL_Y))
                        }

                    },2000)

                }

                if (_floorID != $VAR.map.currentMapInfo.mapID) {
                    let $zoom = $VAR.map.getZoom();
                    $VAR.map.setFloor(_floorID,()=>{
                        $VAR.map.stop().easeTo({
                            zoom:$zoom
                        })
                    });
                    _callee();
                } else {
                    _callee();
                }

            },

            viewBtn(){

                let $brtmap = this.$store.state.mapStore.brtmap,
                    route = $brtmap.$route.route;

                if(!this.beforeZoom){
                    this.beforeZoom = $VAR.map.getZoom();
                    // console.log('初始值',this.beforeZoom);
                }

                //记录导航层级
                // if(this.$mapStep.type=="toNAVING"){
                //
                //     $VAR.$nav.pause();
                //
                //     if(!$VAR.$nav.navZoom){
                //         $VAR.$nav.navZoom = $VAR.map.getZoom();
                //     }
                // }


                //同一层
                if(this.moduleState == 3){

                    // this.moduleState = 2;
                    this.bus.$emit('overViewNAVING',{status:1});//全览操作

                    setTimeout(()=>{
                        this.changeView($VAR.map.currentMapInfo);
                    },100)


                }

                else if(this.moduleState == 1){    //返回

                    this.bus.$emit('overViewNAVING',{status:1});//全览操作

                    this.moduleState = route.length > 1 ? 2 : 3 ;
                    // $VAR.map.setMaxBounds($VAR.map.currentMapInfo.getBounds(0.2));

                }

                else if(this.moduleState == 2){

                    this.moduleState = route.length > 1 ? 1 :3;

                    // $VAR.map.setMaxBounds($VAR.map.currentMapInfo.getBounds(0.2));

                    let $pluset = this.$mapStore.plugInfo.plugInfo.plugInSettings,
                        $plugNav = JSON.parse($pluset.navigation),
                        $navZoom = $plugNav.defaultRank || 19,
                        $zoom = this.beforeZoom || $navZoom;

                    $VAR.map.stop().easeTo({
                        zoom:$zoom
                    })

                    //设置当前起点
                    if(this.$BRT.$NAVTO.NAVType == 'NAVINDICATE'){

                        if($VAR.map.currentMapInfo.floorNumber != $brtmap.$locate.point.floor){ //切换楼层

                                let $floorId = $VAR.map.getFloorInfoByIndex($brtmap.$locate.point.floor).floorID;

                                $VAR.map.setFloor($floorId,()=>{
                                    $VAR.map.stop().easeTo({
                                        zoom:$zoom
                                    })
                                });

                        }

                        if($brtmap.$locate.point){
                            // $VAR.map.setCenter($brtmap.$locate.point) //冲突
                            $VAR.map.stop().easeTo({
                                zoom:$zoom,
                                center:$brtmap.$locate.point
                            })
                        }

                    }

                    else{//设置起点为中心


                        let $startPoint = $brtmap.$selecte.startPoint,
                            lngLat = $startPoint.x ?  $VAR.map.coordsToLnglat($startPoint.x,$startPoint.y) : $VAR.map.coordsToLnglat($startPoint.LABEL_X,$startPoint.LABEL_Y);

                            if($startPoint.x){

                                if($VAR.map.currentMapInfo.floorNumber != $startPoint.floor){

                                    let $floorId = $VAR.map.getFloorInfoByIndex($startPoint.floor).floorID;

                                    $VAR.map.setFloor($floorId,()=>{
                                        $VAR.map.stop().easeTo({
                                            zoom:$zoom,
                                            center:lngLat
                                        })
                                    });

                                }

                            }

                        $VAR.map.stop().easeTo({
                            zoom:$zoom,
                            center:lngLat
                        })
                        // $VAR.map.setCenter(lngLat);
                    }

                    setTimeout(()=>{    //取消全览限制

                        this.beforeZoom = '';

                        if(this.$mapStep.type=="toNAVING" && this.$BRT.$NAVTO.NAVType != 'NAVINDICATE_END'){
                            $VAR.$nav.resume();
                        }

                        this.bus.$emit('overViewNAVING',{status:0});

                    },300)


                    // //导航层级
                    // $VAR.map.easeTo({
                    //     zoom:JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.navigation).defaultRank ? JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.navigation).defaultRank : 19
                    // })
                }


            }


            },

        watch:{
            route(v1,v2){
                this.setView(v1);
            }
        },

        computed:{

            route(){
                return this.$store.state.mapStore.brtmap.$route.route;
            },


        },

        mounted(){

            this.$store.state.mapStore.brtmap.$route.route ? this.setView(this.$store.state.mapStore.brtmap.$route.route) : '';

        }
    }
</script>

<style lang="less">
@import "OverviewModule.less";
</style>
